import React from 'react'

import { Cell } from 'elements/layout/Cell'
import { PreloadDiv } from 'elements/layout/PreloadDiv'
import { Row } from 'elements/layout/Row'

export const PreloadTabsBar: TFC = () => (
  <Row>
    <Cell p="10px 1em">
      <PreloadDiv w="60%" h="30px" />
    </Cell>
    <Cell p="10px 1em">
      <PreloadDiv w="60%" h="30px" />
    </Cell>
  </Row>
)
